module.exports = {
  "id": "9a6c06ec-d7b5-4156-a016-0bcfb2c7683d",
  "gtmIds": [
    "GTM-TWJT45XN",
    "GTM-KBFZSCX9"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "Indiana Beach",
  "language": "en-US",
  "defaultDateFormat": {
    "id": 2,
    "format": "MM/DD/YYYY",
    "name": "Numeric Month First (04/23/2026)"
  },
  "defaultNumberFormat": {
    "id": 1,
    "name": "English (Comma thousands, Dot decimals)",
    "format": "#,###.##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.indianabeach.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}